import { BaseApiService } from './baseApiService';
import { IUser } from './models';

export interface IUserOrganization {
  id: string;
  businessId: string;
  organizationName: string;
  organizationKind: 'Accreditor' | 'Board' | 'Provider' | 'SpecialOrganization';
  childOrganizationIds: Array<string>;
  isJa?: boolean;
}

export interface ICurrentUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  defaultOrganizationId?: string;
  userOrganizations: Array<IUserOrganization>;
}

export class UserApiService extends BaseApiService {
  public async getCurrent(): Promise<IUser> {
    return await super.getAsync('/api/users/current');
  }
}
